import { useMutation } from "@tanstack/react-query";
import { downloadEmploymentsExport } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

export enum ReportContentType {
  CSV = "text/csv",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

const REPORT_FILTER_MAP: Record<string, string> = {
  employed: "HEADCOUNT",
  incoming: "JOINERS",
  leaving: "LEAVERS",
};

interface ReportDownloadParams {
  companyId: string;
  structureId: string;
  contentType: ReportContentType;
  from: string;
  to: string;
  reportId: string;
}

const useDownloadReport = () =>
  useMutation({
    mutationFn: async (params: ReportDownloadParams) => {
      const filter = REPORT_FILTER_MAP[params.reportId];
      const response = await downloadEmploymentsExport({
        companyId: params.companyId,
        structureId: params.structureId,
        contentType: params.contentType,
        from: params.from,
        to: params.to,
        filter,
      });

      const contentDisposition =
        response.headers["content-disposition"] ?? "";
      let fileName = "";

      const utf8Index = contentDisposition.indexOf("''");
      if (utf8Index !== -1) {
        fileName = decodeURIComponent(
          contentDisposition.substring(utf8Index + 2)
        );
      } else {
        const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
        fileName = match?.[1] ?? "export";
      }

      const file = await response.data.arrayBuffer();
      const url = URL.createObjectURL(new Blob([file]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    onError: () => {
      dynamicNotification(
        __("Nie udało się pobrać pliku. Spróbuj ponownie."),
        "error"
      );
    },
  });

export default useDownloadReport;
